// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      // eslint-disable-next-line
      tasksQAOptions: [
        "Standard",
        "Certificate",
        "Review"
      ],
      // eslint-disable-next-line
      tasksDeliveryOrginOptions: [
        "Local",
        "State",
        "National",
        "Overseas"
      ],
      // eslint-disable-next-line
      tasksSourceOptions: [
        "Reuse",
        "Site",
        "Workshop",
        "Warehouse",
        "External"
      ],
      // eslint-disable-next-line
      tasksTypeOptions: [
        "Isolate",
        "Verify",
        "Inspect",
        "Test",
        "Action",
        "Open",
        "Close",
        "Purge",
        "Press",
        "Start",
        "Shutdown",
        "Change",
        "Check",
        "Inspect",
        "Check",
        "Clean",
        "Grease",
        "Set",
        "Monitor",
        "Contact",
        "Connect",
        "Disconnect"
      ],
      // eslint-disable-next-line
      tasksThemeOptions: [
        "S",
        "P",
        "D",
        "T",
        "C",
        "Q"
      ],
      // eslint-disable-next-line
      tasksUnitOptions: [
        "unit",
        "pkg",
        "skid",
        "drum"
      ],
      // eslint-disable-next-line
      tasksStatusOptions: [
        "Created",
        "Ready",
        "Progress",
        "Issue",

      ],
      // eslint-disable-next-line
      tasksUnitsOptions: [
        "Reuse",
        "Site",
        "Workshop",
        "Warehouse",
        "Order"
      ],
      // eslint-disable-next-line
      taskActivityTypeOptions: [
        "Isolate",
        "Verify",
        "Inspect",
        "Test",
        "Action",
        "Open",
        "Close",
        "Purge",
        "Press",
        "Start",
        "Shutdown",
        "Change",
        "Check",
        "Inspect",
        "Check",
        "Clean",
        "Grease",
        "Set",
        "Monitor",
        "Contact",
        "Connect",
        "Disconnect"
      ]
    };
  }
};
